import {SHOW_OVERLAY_MODAL_TYPES} from './ModalStore.constants';
import {ModalState, ModalType} from '@/stores/ModalStore/ModalStore.types';

import {injected} from 'brandi';

import {Store} from '@/stores/Store';

const initialModalState: ModalState = {
  currentModal: null,
};

export class ModalStore extends Store<ModalState> {
  constructor() {
    super(initialModalState);
  }

  public getCurrentModalType = (): ModalType | null => {
    return this.getState().currentModal;
  };

  public setCurrentModalType = (currentModal: ModalType): void => {
    this.setState({currentModal});
  };

  public resetCurrentModalType = (): void => {
    this.resetState();
  };

  public isNoModalOpened = (): boolean => {
    const currentModal = this.getCurrentModalType();

    return currentModal === null;
  };

  public isCurrentSettingsModal = (): boolean => {
    const currentModal = this.getCurrentModalType();

    return currentModal === ModalType.Settings;
  };

  public isCurrentBonusesModal = (): boolean => {
    const currentModal = this.getCurrentModalType();

    return currentModal === ModalType.Bonuses;
  };

  public isCurrentItemInfoModal = (): boolean => {
    const currentModal = this.getCurrentModalType();

    return currentModal === ModalType.ItemInfo;
  };

  public isCurrentItemCardModal = (): boolean => {
    const currentModal = this.getCurrentModalType();

    return currentModal === ModalType.ItemCard;
  };

  public isOverlayAboveBar = (): boolean => {
    const currentModal = this.getCurrentModalType();

    if (currentModal === null) {
      return false;
    }

    return SHOW_OVERLAY_MODAL_TYPES.includes(currentModal);
  };
}

injected(ModalStore);
